import { useEffect, useRef } from 'react';
import { useFetchGetTechAbility } from '~/src/repositories/lead/hooks/use-fetch-tech-ability.hook';

export const useInternetTechAbility = (
    isInternetSelected: boolean,
    getHouseFiasId: () => string,
) => {
    const { data, isLoading, fetchTechAbility, isError, reset } = useFetchGetTechAbility();
    const prevIsInternetSelectedRef = useRef(isInternetSelected);

    useEffect(() => {
        const internetJustSelected = !prevIsInternetSelectedRef.current && isInternetSelected;
        const internetJustDeselected = prevIsInternetSelectedRef.current && !isInternetSelected;

        prevIsInternetSelectedRef.current = isInternetSelected;

        if (internetJustSelected && getHouseFiasId()) {
            fetchTechAbility(getHouseFiasId());
            return;
        }

        if (internetJustDeselected) {
            reset();
        }
    }, [isInternetSelected, fetchTechAbility, reset, getHouseFiasId]);

    const shouldShowPlank = isLoading || isError || Boolean(data);

    return {
        data,
        isLoading,
        isError,
        fetchTechAbility,
        reset,
        shouldShowPlank,
    };
};
